import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-form-group-part-header',
  templateUrl: './form-group-part-header.component.html',
  styleUrls: ['./form-group-part-header.component.scss'],
  standalone: false,
})
export class FormGroupPartHeaderComponent implements OnInit {
  ngOnInit(): void {}
}
